import metaTags from '@/finsight/ui/common/metaTagsConstants';
import URL from '@/finsight/Router/urlConstants';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

type TgetMarketOverviewMetaTags = Pick<IgetMetaTagsByFilters, 'isConsumerOverview' | 'pathname'>;

const META_TAGS_MAPPER = {
  [URL.MARKET_OVERVIEW_IGC]: metaTags.getMarketOverviewIGC(),
  [URL.MARKET_OVERVIEW_HYC]: metaTags.getMarketOverviewHYC(),
  [URL.MARKET_OVERVIEW_ALL]: metaTags.getMarketOverviewUsAbs(),
};

export const getMarketOverviewMetaTags = ({
  isConsumerOverview, pathname,
}: TgetMarketOverviewMetaTags): IMetaTags => (
  isConsumerOverview ? metaTags.getMarketOverviewCustomer() : META_TAGS_MAPPER[pathname]
);
